module.exports = __webpack_public_path__ + "img/Show Icon - charcoal.fe053e74.svg";